// extracted by mini-css-extract-plugin
module.exports = {"box":"SidebarBox_box__3VH8S","boxTitle":"SidebarBox_boxTitle__2zYtG","btnToggle":"SidebarBox_btnToggle__1hPnE","boxBody":"SidebarBox_boxBody__GfKQe"};